import normalize from "app/utils/normalize";

export const buttonVariants = {
  defaults: {
    padding: {
      phone: "s",
      web: "l",
    },
    justifyContent: "center",
    alignItems: "center",
    opacity: 1,
    paddingHorizontal: "xm",
    paddingVertical: "s",
  },
  plainButton: {
    padding: {
      phone: "s",
      web: "l",
    },
    margin: {
      phone: "s",
    },
  },
  roundButton: {
    borderRadius: normalize(100),
  },
  strokeButton: {
    borderColor: "brand.500",
    borderWidth: normalize(2),
    borderStyle: "solid",
    borderRadius: normalize(8),
    paddingHorizontal: "m",
    paddingVertical: "s",
  },
};
